module.exports = __webpack_public_path__ + "74fb21d6c3926d67b9fe9f3e1903d69d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/skillset-icons/icon-tundra.png
// module id = 3667
// module chunks = 0